import axios from 'axios';

export const LOGO_TYPE = 'logo';
export const RETURN_TYPE = 'return';
export const INDEX_RETURN_TYPE = 'indexReturn';
export const EMPTY_TYPE = 'leftEmpty';
export const HIDE_TYPE = 'hide';
export const TYPE_ENUM = [LOGO_TYPE, RETURN_TYPE, INDEX_RETURN_TYPE, EMPTY_TYPE, HIDE_TYPE];

/**
 *
 * @param {Object} _pendingData 等待对象
 * @param {String} key 设置到vue中的数据key
 * @param {Function} paramsValid 校验函数
 */
export function funcFactory(_pendingData, key, paramsValid) {
    return function(params) {
        if (paramsValid && !paramsValid(params)) {
            return new Error(`invalid ${key}`);
        }
        if (typeof this[key] !== 'undefined') {
            this._data[key] = params; // 更新状态
        } else {
            _pendingData[key] = params;
        }
        return this;
    };
}

export function isNeibu() {
    return /neibu/.test(window.location.hostname);
}

export function isLogin() {
    return document.cookie.indexOf('sso.ssoId=') > -1 || document.cookie.indexOf('sid=') > -1;
}

export const stringKVscene = [
    { keyword: '首页_用户中心_注册', scene: 'M_sy_uc_register' },
    { keyword: '首页_近期直播_注册', scene: 'M_sy_zhibo_register' },
    { keyword: '首页_2020真题解析_注册', scene: 'M_sy_video_register' },
    { keyword: '首页_功能区_21考研', scene: 'M_sy_gn_21ke' },
    { keyword: '首页_功能区_低价体验课', scene: 'M_sy_gn_flow' },
    { keyword: '首页_功能区_名字待确定', scene: 'M_sy_gn_zhuanti' },
    { keyword: '首页_功能区_上岸秘籍', scene: 'M_sy_gn_yati' },
    { keyword: '首页_功能区_一起背单词', scene: 'M_sy_gn_yanci' },
    { keyword: '首页_在线咨询_在线咨询', scene: 'M_sy_consult' },
    { keyword: '考研月历_用户中心_注册', scene: 'M_kyyl_uc_register' },
    { keyword: '考研月历_广告线索框_注册', scene: 'M_kyyl_ad_register' },
    { keyword: '择校工具箱_用户中心_注册', scene: 'M_zxgj_uc_register' },
    { keyword: '择校工具箱_智能择校_注册', scene: 'M_zxgj_znzx_register' },
    { keyword: '择校工具箱_学校检索_注册', scene: 'M_zxgj_university_register' },
    { keyword: '择校工具箱_专业检索_注册', scene: 'M_zxgj_major_register' },
    { keyword: '择校工具箱_历年分数线_注册', scene: 'M_zxgj_fsx_register' },
    { keyword: '历年真题_用户中心_注册', scene: 'M_llzt_uc_register' },
    { keyword: '历年真题_科目_注册', scene: 'M_llzt_subject_register' },
    { keyword: '历年真题_科目下的年份_注册', scene: 'M_llzt_session_register' },
    { keyword: '备考攻略_用户中心_注册', scene: 'M_bkgl_uc_register' },
    { keyword: '上岸秘籍_用户中心_注册', scene: 'M_yati_uc_register' },
    { keyword: '上岸秘籍_购课按钮_跳转21课表', scene: 'M_yati_btn_21ke' },
    { keyword: '一起背单词_用户中心_注册', scene: 'M_yanci_uc_register' },
    { keyword: '一起背单词_立即报名按钮_注册', scene: 'M_yanci_btn_register' },
    { keyword: '2020真题解析_用户中心_注册', scene: 'M_video_uc_register' },
    { keyword: '2020真题解析_视频卡片_注册', scene: 'M_video_card_register' },
    { keyword: '考研资讯_用户中心_注册', scene: 'M_kyzx_uc_register' },
    { keyword: '文章详情页_用户中心_注册', scene: 'M_article_uc_register' },
    { keyword: '文章详情页_广告位_注册', scene: 'M_article_ad_register' },
    { keyword: '视频详情页_用户中心_注册', scene: 'M_vpage_uc_register' },
    { keyword: '视频详情页_视频卡片_注册', scene: 'M_vpage_card_register' },
    { keyword: '学校检索_用户中心_注册', scene: 'M_university_uc_register' },
    { keyword: '专业检索_用户中心_注册', scene: 'M_major_uc_register' },
    { keyword: '历年分数线_用户中心_注册', scene: 'M_fsx_uc_register' },
];

export const POST = (url, data) => {
    if (!data) data = {};
    return axios
        .post(url, data)
        .then((json) => {
            return json.data;
        })
        .then((data) => {
            if (data.code === 0) {
                return data.data;
            }
            console.error(data);
            return Promise.reject(data.msg);
        });
};

export const getCookie = (name) => {
    let { cookie } = document;
    //  第一次分割
    let items = cookie.split(';');
    let keys = {};
    items.forEach((item) => {
        //  第二次分割
        let kv = item.split('=');
        keys[kv[0].trim()] = kv[1].trim();
    });
    // console.log(keys);
    return keys[name];
};
